require('./SuccessStep.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
// @commons
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { formatText, FormattedText } = require('core/i18n').i18n;

class SuccessStepFatca extends React.Component {

    render() {
        const successMessage = formatText('profileEditSuccessFatca-title');
        const mainButton = {
            label: (<FormattedText value="profileEditSuccessFatca-backButtonLabel"/>)
        };

        return (
            <div className="confirm-success-step col-xs-offset-2 col-xs-8">
                <WizardSuccess
                    successMessage={successMessage}
                    mainButton={mainButton}
                    onMainButtonClick={this.props.onConfirmLeave}
                >
                    <p>
                        <FormattedText value="profileEditSuccessFatca-text" />
                    </p>
                </WizardSuccess>
            </div>
        );
    }
}

SuccessStepFatca.propTypes = {
    onConfirmLeave: PropTypes.func.isRequired,
};

module.exports = SuccessStepFatca;
